<template>
  <base-layout :doSkipHeader="true">
    <template v-slot:main>
      <div v-if="user" >
        <div class="grid grid-cols-12 gap-6">
          
          <div class="col-span-12 lg:col-span-12 bg-white shadow overflow-hidden sm:rounded-lg">
            <div class="flex flex-col items-center mt-6 sm:mt-10">
               <img src="/img/escrow_button.png"
                  alt="Escrow Logo"
                  class="h-16 sm:h-20 w-auto"
                />
            </div>

            <div v-if="!transactionCreated" class=" mx-6 m-4 text-base text-justify leading-6 text-gray-800 font-bold">
              You are about to initiate an Escrow deal. This deal will be processed securely through the trusted Escrow.com
              platform and is conducted entirely outside of the TBS website. For more information, please visit 
              <a class="text-red-500" href="https://www.escrow.com" target="_blank">Escrow.com</a> 
            </div>

            <div v-if="transactionCreated">
              <div class="mx-6 my-10 text-lg p-6 rounded text-white" style="background-color: #3cb95d;">
                Your Escrow deal has been successfully created. You will receive an email with the next steps shortly. 
                Please check your inbox, including your spam or junk folder, as delivery may take a few minutes.
              </div>
              <div v-if="broadcastId" class="flex justify-center mb-8">
                <button class="bg-red-600 text-white rounded-full hover:bg-red-700 px-6 py-4"
                @click="navToBroadcast()"
                >Back to Broadcast</button>
              </div>
            </div>
            <div v-else class="flex flex-col sm:flex-row gap-6 p-6">
              <div class="w-full sm:w-1/3 flex flex-col h-full">
                <div class="bg-white shadow-lg rounded-2xl border border-gray-100 overflow-hidden flex-shrink-0">
                  <div class="bg-red-600 text-white px-4 py-4">
                    <h2 class="text-lg font-bold">Member Details</h2>
                  </div>
                  <div class="p-4 mt-1">
                    <div class="mb-4">
                      <div class="flex justify-between items-center">
                        <h2 class="text-lg mb-2 text-gray-800 font-bold">Buyer Details</h2>
                        <p v-if="!broadcastId && role =='seller' && contacts" class="text-sm cursor-pointer"
                          :class="!editingBuyer ? 'text-red-500' : 'text-green-500'"
                          @click="toggleBuyerEdit">
                          {{ editingBuyer ? 'Save' : 'Change Buyer' }}
                        </p>
                      </div>
                      <div class="text-sm text-gray-500">
                        <div class="flex items-center mb-1">
                          <span class="font-medium w-24">Name:</span>
                          <span v-if="!editingBuyer">{{ form.buyer.name }}</span>
  
                          <select v-else v-model="form.buyer.name" class="border rounded px-2 py-1 w-full text-sm">
                            <option v-for="contact in contacts" :key="contact.name" :value="contact.name">
                              {{ contact.name }}
                            </option>
                          </select>
                        </div>
  
                        <div class="flex items-center mb-1">
                          <span class="font-medium w-24">Company:</span>
                          <span>{{ form.buyer.companyName }}</span>
                        </div>
  
                        <div class="flex items-center">
                          <span class="font-medium w-24">Phone:</span>
                          <span>{{ form.buyer.tel }}</span>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <div class="my-4">
                      <div>
                        <div class="flex justify-between items-center">
                          <h2 class="text-lg mb-2 text-gray-800 font-bold">Seller Details</h2>
                          <p v-if="!broadcastId && role=='buyer' && contacts" class="text-sm cursor-pointer"
                            :class="!editingSeller ? 'text-red-500' : 'text-green-500'"
                            @click="toggleSellerEdit">
                            {{ editingSeller ? 'Save' : 'Change Seller' }}
                          </p>
                        </div>
  
                        <div class="text-sm text-gray-500">
                          <div class="flex items-center mb-1">
                            <span class="font-medium w-24">Name:</span>
                            <span v-if="!editingSeller">{{ form.seller.name }}</span>
  
                            <select v-else v-model="form.seller.name" class="border rounded px-2 py-1 w-full text-sm">
                              <option v-for="contact in contacts" :key="contact.name" :value="contact.name">
                                {{ contact.name }}
                              </option>
                            </select>
                          </div>
  
                          <div class="flex items-center mb-1">
                            <span class="font-medium w-24">Company:</span>
                            <span>{{ form.seller.companyName }}</span>
                          </div>
  
                          <div class="flex items-center">
                            <span class="font-medium w-24">Phone:</span>
                            <span>{{ form.seller.tel }}</span>
                          </div>
  
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bg-white mt-3 shadow-lg rounded-2xl border border-gray-100 overflow-hidden flex-1 flex flex-col">
                  <div class="text-white px-4 py-2 mt bg-gray-400">
                    <h2 class="font-bold text-sm">How does an Escrow deal work?</h2>
                  </div>
                  <div class="p-4 mt-1 text-xs text-gray-700 text-justify space-y-2">
                    <p>1. Submit this deal to Escrow.com</p>
                    <p>2. Receive email confirmations of your deal, using your Escrow account (or create a new account if you don't have one yet)</p>
                    <p>3. Proceed on the Escrow.com platform for 100% safe and secure transactions</p>

                  </div>
                  <p class="p-4 text-xs text-gray-700">For more information, visit: 
                    <a href="https://www.escrow.com/what-is-escrow" class="text-red-600 font-bold" target="_blank">https://www.escrow.com/what-is-escrow</a>
                  </p>
                
                </div>
              </div>

              <div class="bg-white shadow-lg rounded-2xl w-full sm:w-2/3  border border-gray-100 overflow-hidden">
                <!-- Card Header -->
                <div class="bg-red-600 text-white px-4 py-4">
                  <h2 class="text-lg font-bold">Deal Details</h2>
                </div>
                <div v-if="broadcastId" class="m-4 rounded">
                  <div class=" text-red-600 font-bold text-lg mb-4 h-auto">
                    Broadcast Details
                  </div>
                  <div v-if="broadcast" v-html="formattedSubject" class="break-words mb-10 clearfix"></div>
                  <div v-else class=" my-6 space-y-4 animate-pulse">
                    <!-- Rows -->
                    <div class="space-y-2">
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-32"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-56"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-52"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-52"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-52"></div>
                      <div class="h-5 sm:h-4 bg-gray-200 rounded w-40"></div>
                    </div>
                  </div>

                </div>
                <div>
                  <ValidationObserver ref="observer" v-slot="{ invalid }">
                    <form @submit.prevent="handleSubmit">
                      <div class="p-4">
                        <ValidationProvider name="Buyer Email" rules="required|email" v-slot="{ errors }">
                          <div class="mb-4">
                          <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-full sm:w-40">Buyer:</label>
  
                              <input 
                                type="email" 
                                v-model="form.buyer.email"
                                :class="[
                                  'w-full border rounded px-3 py-2 focus:outline-none',
                                  errors[0]
                                    ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                ]"
                              />
                            </div>
  
                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt4" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>
  
                        <ValidationProvider name="Seller Email" rules="required|email" v-slot="{ errors }">
                          <div class="mb-4">
                          <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-32 sm:w-40 w-full">Seller:</label>
  
                              <input
                                type="email"
                                v-model="form.seller.email"
                                :class="[
                                  'w-full border rounded px-3 py-2 focus:outline-none',
                                  errors[0]
                                    ? 'border-red-500 focus:ring-2 focus:ring-red-400'
                                    : 'border-gray-300 focus:ring-2 focus:ring-blue-500'
                                ]"
                              />
                            </div>
  
                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt4" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>
  

                        <div v-if="!broadcastId">
                          <!-- Broadcast Type -->
                          <ValidationProvider name="Broadcast type" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium sm:w-40 w-full">Broadcast Type:</label>
                                <select v-model='broadcastPayload.listType'
                                  :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 
                                  'border-red-500 focus:ring-2 focus:ring-red-400' : 
                                  'border-gray-300 focus:ring-2 focus:ring-blue-500']">
                                  <option value="" selected>Please select broadcast list</option>
                                  <option v-for="(option, index) in broadcastOptions" :key="index" :value="option.name">
                                    {{ option.label }}
                                  </option>
                                </select>
                                <!-- <input v-model="quantity" 
                                  type="number" 
                                  :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']"/> -->
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>

                          <!-- Brand -->
                          <ValidationProvider name="Brand" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Brand:</label>
                                <input v-model="broadcastPayload.brand" 
                                  type="text" 
                                  :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']"/>
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>

                          <!-- Desc/PartNumber -->
                          <ValidationProvider name="Desc./Partnumber" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Desc./Partnumber:</label>
                                <input v-model="broadcastPayload.desc" 
                                  type="text" 
                                  :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']"/>
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>


                          <ValidationProvider name="Condition" rules="required" v-slot="{ errors }">
                            <div class="mb-4">
                              <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                                <label class="text-sm font-medium w-32 sm:w-40 w-full">Condition</label>
                                <input v-model="broadcastPayload.condition" 
                                  type="text" 
                                  :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']"/>
                              </div>
                              <div class="flex flex-row-reverse">
                                <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                              </div>
                            </div>
                          </ValidationProvider>
                        </div>


                        <ValidationProvider name="Amount" rules="required|numeric|positive" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium sm:w-40 w-full">Amount:</label>
                              <div class="flex w-full">
                                <!-- Amount input -->
                                <input v-model="extractedPriceCurrency.price"
                                  type="number"
                                  class="rounded-l border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                  :class="['w-full', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']"
  
                                />
  
                                <!-- Currency select -->
                                <select v-model="extractedPriceCurrency.currency"
                                  class="rounded-r border border-gray-300 border-l-0 px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                                  >
                                  <option v-for="c in currencies" :key="c" :value="c.toLowerCase()">
                                    {{ c }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>
  
                        <ValidationProvider name="Quantity" rules="required|numeric|positive" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium w-32 sm:w-40 w-full">Quantity:</label>
                              <input v-model="quantity" 
                                type="number" 
                                :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']"/>
                            </div>
                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>

                        <ValidationProvider name="Escrow Fee Payer" rules="required" v-slot="{ errors }">
                          <div class="mb-4">
                            <div class="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                              <label class="text-sm font-medium sm:w-40 w-full">Escrow Fee Payer:</label>
                              <select v-model='escrowFeePayer'
                                :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 
                                'border-red-500 focus:ring-2 focus:ring-red-400' : 
                                'border-gray-300 focus:ring-2 focus:ring-blue-500']">
                                <option value="me">(Me) {{ user.email }}</option>
                                <option value="half">Split 50–50</option>
                                <option v-if="otherParty" value="otherParty">{{ otherParty }}</option>
                              </select>
                              <!-- <input v-model="quantity" 
                                type="number" 
                                :class="['w-full border rounded px-3 py-2 focus:outline-none', errors[0] ? 'border-red-500 focus:ring-2 focus:ring-red-400' : 'border-gray-300 focus:ring-2 focus:ring-blue-500']"/> -->
                            </div>
                            <div class="flex flex-row-reverse">
                              <p class="text-red-600 text-sm mt-1" v-if="errors[0]">{{ errors[0] }}</p>
                            </div>
                          </div>
                        </ValidationProvider>

                        <div class="flex flex-row-reverse">
                            <button class="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 flex items-center justify-center"
                              type="submit" :disabled="invalid ||  isCreatingTransaction">

                              <template v-if="isCreatingTransaction" class="flex">
                                <svg class="w-5 h-5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                  <path class="opacity-75" fill="currentColor"
                                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z">
                                  </path>
                                </svg>
                                <span class="mx-2">Submitting...</span>
                              </template>

                              <template v-else>
                                Submit Deal to Escrow.com
                              </template>
                            </button>
                        </div>
                      </div>  
                    </form>
                  </ValidationObserver>
                </div>
              </div>
            </div>  

            <div v-if="broadcastId && !transactionCreated && !user">
              <div class="grid grid-cols-2 px-4 py-1  sm:px-6">
                <div class="text-left">
                  <h3 class="text-lg leading-6 text-red-500 font-bold">Broadcast Details</h3>
                </div>
              </div>

              <div v-if="broadcast"  class='px-6 my-6'>
                <div v-html="formattedSubject" class="break-words mb-6"></div>
                <br>
              </div>
              <div v-else class="px-6 my-6 space-y-4 animate-pulse">
                <!-- Title -->
                <div class="h-5 bg-gray-300 rounded w-48"></div>

                <!-- Rows -->
                <div class="space-y-2">
                  <div class="h-4 bg-gray-200 rounded w-32"></div>
                  <div class="h-4 bg-gray-200 rounded w-56"></div>
                  <div class="h-4 bg-gray-200 rounded w-40"></div>
                  <div class="h-4 bg-gray-200 rounded w-52"></div>
                </div>

                <!-- Paragraph block -->
                <div class="mt-4 space-y-2">
                  <div class="h-3 bg-gray-200 rounded"></div>
                  <div class="h-3 bg-gray-200 rounded w-4/5"></div>
                  <div class="h-3 bg-gray-200 rounded w-3/5"></div>
                </div>

                <!-- Contact block -->
                <div class="mt-4 space-y-2">
                  <div class="h-4 bg-gray-200 rounded w-64"></div>
                  <div class="h-3 bg-gray-200 rounded w-48"></div>
                  <div class="h-3 bg-gray-200 rounded w-36"></div>
                </div>

                <!-- Banner -->
                <div class="h-24 bg-gray-300 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-layout>
</template>

<script>

import {  mapState } from 'vuex'
import BaseLayout from '@/components/BaseLayout.vue'

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

import store from '../store'
import eventBus from '../utils/eventBus'
import { mapActions } from 'vuex/dist/vuex.common.js';

const _ = require('lodash');


extend("required", {
  ...required,
  message: "{_field_} is required."
});
extend("email", {
  ...email,
  message: "Please enter a valid email."
});
extend("numeric", {
  validate: value => !isNaN(value),
  message: "{_field_} must be a number."
});
extend("positive", {
  validate: value => {
    const num = parseFloat(value);
    return !isNaN(num) && num > 0;
  },
  message: "{_field_} must be a number greater than 0."
});

export default {
  name: 'CompanyDetail',
  components: {
    BaseLayout,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState(['user', 'broadcastMap']),
    extractedPriceCurrency() {
        const subject = this.broadcast?.subject || "";

        // get text after the last comma
        const lastPart = subject.split(",").pop().trim();

        // currency list
        const currencies = ["EUR", "USD", "GBP"];

        // extract currency
        let currency = (
          currencies.find(c =>
            new RegExp(`\\b${c}\\b`, "i").test(lastPart)
          ) || "EUR"
        ).toLowerCase();

        // extract price number
        let priceMatch = lastPart.match(/(\d+(\.\d+)?)/);
        let price = priceMatch ? parseFloat(priceMatch[0]) : 0;

        return { price, currency };
    },
    formattedSubject() {
      const message = this.broadcast?.messageFormatted || '';

      // Find first "Price:"
      const priceIndex = message.indexOf('Price:');
      if (priceIndex === -1) return '';

      // Find first literal "\n" after "Price:"
      const newlineIndex = message.indexOf('<br><br>', priceIndex); // note double backslash

      if (newlineIndex === -1) {
        return "test"; // no newline found
      }

      // Return from 0 to the newline
      return message.substring(0, newlineIndex);

    },
    broadcastOptions() {
      return _.orderBy(_.map(this.broadcastMap, (cat, id) => _.extend({
        id,
        label: `${cat?.name} Broadcasts`,
      }, cat)), "order")
    },
  },
  data() {
    return {
      broadcast: null,
      company: null,
      broadcastId: this.$route.query.bcId,
      role: ["buyer", "seller"].includes(this.$route.query.role) 
        ? this.$route.query.role 
        : "buyer",      
      companyId: null,
      contacts: null,
      quantity: 0,
      editingSeller: false,
      editingBuyer: false,
      selectedContactId: null,
      isCreatingTransaction: false,
      transactionCreated: false,
      otherParty: "",
      escrowFeePayer: "me",
      broadcastPayload: {
        listType: "",
        broadcastType: "wts",
        brand: null,
        desc: null,
        condition: null,
      },
      form: {
        buyer: {
          name: "",
          companyName: "",
          email: "",
          tel: "",
        },
        seller: {
          name: "",
          companyName: "",
          email: "",
          tel: "",
        },
      },
      currencies: ["EUR", "USD",  "GBP"]
    }
  },
  watch: {
    broadcast(newVal) {
      if (!newVal) return;
      
      const subject = newVal.subject;
      const colonIndex = subject.indexOf(':');

      this.quantity = parseInt((newVal?.quantity || '').replace(/\D/g, ''), 10) || 0;
      this.selectedContactId = newVal.contactId;
      this.otherParty = newVal.contact?.email ?? "";

      let broadcastSenderRole = "seller";
      let userRole = "buyer";

      if (colonIndex !== -1)  {
        const fiveCharsBeforeColon = subject.substring(Math.max(0, colonIndex - 5), colonIndex);

        if (fiveCharsBeforeColon.includes("WTB")) {
          broadcastSenderRole = "buyer";
          userRole = "seller";
        } else if (fiveCharsBeforeColon.includes("WTS")) {
          broadcastSenderRole = "seller";
          userRole = "buyer";
        }

      }  

      this.role = userRole;
      this.form[broadcastSenderRole] = {
        name: newVal.contact?.name ?? "",
        companyName: newVal.company?.name ?? "",
        email: newVal.contact?.email ?? "",
        tel: newVal.contact?.tel ?? "",
      };

      this.form[userRole] = {
        name: this.user?.name ?? "",
        companyName: this.user?.companyName ?? "",
        email: this.user?.email ?? "",
        tel: this.user?.tel ?? "",
      };
    },
    company(newVal) {
      if (!newVal) return;

      // Find the correct contact based on contactType
      const primaryContact = newVal.contacts?.find(c => c.contactType === 1) 
        || newVal.contacts?.[0] 
        || null;
      
      this.selectedContactId = primaryContact.id
      this.otherParty = primaryContact?.email ?? "";

      this.contacts = newVal.contacts;
      
      const target = this.role === "buyer" ? "seller" : "buyer";
      this.form[target] = {
        name: primaryContact?.name ?? "",
        companyName: newVal.name ?? "",
        email: primaryContact?.email ?? "",
        tel: primaryContact?.tel ?? "",
      };
    }, 
    user(newVal) {
      if (!newVal || this.broadcastId) return;
      const target = this.role === "buyer" ? "buyer" : "seller";
      this.form[target] = {
        name: this.user?.name ?? "",
        companyName: this.user?.companyName ?? "",
        email: this.user?.email ?? "",
        tel: this.user?.tel ?? "",
      };

    }
  },
  created() {
    const { bcId, companyId } = this.$route.query;

    this.broadcastId = bcId;
    this.companyId = companyId;

    if (this.broadcastId && !isNaN(this.broadcastId)) {
      this.fetchBroadcastData()
    } else if(this.companyId && !isNaN(this.companyId)) {
      this.fetchCompanyData()
    }
  
  },

  methods: {
    ...mapActions(['initiateEscrow', 'getCompany']), 
    async fetchBroadcastData() {
      try {
        const resp = await store.dispatch('getBroadcast', this.broadcastId)
        if (resp.status !== 200) {
          eventBus.$emit("createSnackbar", {
            type: "error",
            title: "Broadcast not found",
            body: resp.msg,
            timeoutInMS: 5000,
          })
          return;
        }
        this.broadcast = resp.broadcast

      } catch (e) {
        console.log("err", e)
      }
    },
    async fetchCompanyData() {
      try {
        const resp = await store.dispatch('getCompany', this.companyId)
        if (resp.status !== 200) {
          eventBus.$emit("createSnackbar", {
            type: "error",
            title: "Company not found",
            body: resp.msg,
            timeoutInMS: 5000,
          })
          return;
        }
        this.company = resp.company
      } catch (e) {
        console.log("err", e)
      }
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate(); // or `validate()` from slot
      if (!isValid) return;
      this.onSubmit();
    },
    async onSubmit() {
      this.isCreatingTransaction = true;
      const payload = {
        buyer: this.form.buyer.email,
        seller: this.form.seller.email,
        broadcastId: this.broadcastId,
        amount: this.extractedPriceCurrency.price,
        quantity: this.quantity,
        companyId: this.broadcast?.companyId ?? this.companyId,
        currency: this.extractedPriceCurrency.currency,
        role: this.role,
        contactId: this.selectedContactId,
        broadcastPayload: this.broadcastPayload,
        escrowFeePayer: this.escrowFeePayer
      };

      console.log(payload);

      const resp = await this.initiateEscrow(payload);

      if (resp.data.status !== 201) {
        eventBus.$emit("createSnackbar", {
          type: "error",
          title: "Something went wrong",
          body: "There was an error creating escrow deal. Please try again.",
          timeoutInMS: 5000,
        })
      } else {
        eventBus.$emit("createSnackbar", {
          type: "success",
          title: "Escrow Deal Created",
          body: "Please check your email for the details.",
        })
      }
      this.isCreatingTransaction = false;
      this.transactionCreated = true;
    },
    removeTelephoneFooter(message) {
      const keyword = "Telephone:";
      const index = message.indexOf(keyword);

      if (index === -1) return message;

      // find the newline at the end of the Telephone line
      const lineBreakAfterTelephone = message.indexOf("<br>", index);

      // if there is a newline after the Telephone line, keep everything up to it
      if (lineBreakAfterTelephone !== -1) {
        return message.substring(0, lineBreakAfterTelephone );
      }

      // if there is no newline, just keep the entire message (Telephone is last line)
      return message;



    },
    toggleSellerEdit() {
      if (this.editingSeller) {
        const selected = this.contacts.find(
          c => c.name === this.form.seller.name
        );

        if (selected) {
          this.form.seller.name = selected.name;
          this.form.seller.email = selected.email || ""; 
          this.form.seller.tel = selected.tel;
          this.selectedContactId = selected.id;
          this.otherParty = selected.email;
        }
        this.editingSeller = false;
      } else {
        this.editingSeller = true;
      }
    },
    toggleBuyerEdit() {
      if (this.editingBuyer) {
        const selected = this.contacts.find(
          c => c.name === this.form.buyer.name
        );

        if (selected) {
          this.form.buyer.name = selected.name;
          this.form.buyer.email = selected.email || ""; 
          this.form.buyer.tel = selected.tel;
          this.selectedContactId = selected.id;
          this.otherParty = selected.email;
        }
        this.editingBuyer = false;
      } else {
        this.editingBuyer = true;
      }
    },
    navToBroadcast() {
      if(!this.broadcastId) return;
      this.$router.push({path: `/broadcasts/${this.broadcastId}`});
    },
    
    
  },
}
</script>
